import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

const initGSAPVerticalText = () => {

	const root = document.querySelector('.hoffman-staggered-headers')

	if (!root) return;

	const sentences = SplitText.create(".sentence", { type: "words, chars" });

	gsap.set(sentences.words, { autoAlpha: 0, yPercent: 25});
	gsap.set(sentences.chars, { autoAlpha: 0, yPercent: 25});
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: root,
			start: 'top 10%',
			end: 'bottom 0%',
			scrub: 3,
			pin:true
		}
	});

	tl.to(sentences.words, {
		yPercent: 0,
		autoAlpha: 1,
		stagger: 0.2,
		duration:2,
		ease: 'power2.inOut',
	}).to(sentences.chars, {
		yPercent: 0,
		autoAlpha: 1,
		stagger: 0.3,
		duration:3,
		ease: 'power2.inOut',
	},'<')


}
export { initGSAPVerticalText };